import { Component, Input } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'm4u-gridbuttonremove',
    templateUrl: './gridbuttonremove.component.html',
    styleUrls: ['./gridbuttonremove.component.scss']
})
export class GridButtonRemoveComponent  
{
    constructor() { }

    @Input() public grid: DxDataGridComponent;
    get gridAny(): any { return this.grid; }
    @Input() public item: any;

}
